import React from "react";
import ImageGallery from "./ImageGallery";

const Calendar = () => {
  const images = [
    {
      title:'Calendar',
      url: "https://webapi.entab.info/api/image/SFSAP/public/Images/breadcrumb.jpg",
      alt: "St. Francis School, Amritsar",
    },
    {
      title:'Calendar',
      url: "https://webapi.entab.info/api/image/SFSAP/public/Images/breadcrumb.jpg",
      alt: "Another Image",
    },
   
  ];

  return (
    <div> 
      <ImageGallery images={images} />
    </div>
  );
};
 
export default Calendar;